import last from 'lodash/last';

export enum VERSION {
    '1.0.0' = '1.0.0',
    '2.0.0' = '2.0.0',
    '2.0.1' = '2.0.1',
    '3.0.0' = '3.0.0',
    '3.1.0' = '3.1.0',
    '4.0.0' = '4.0.0',
    '4.1.0' = '4.1.0',
    '5.0.0' = '5.0.0',
    '5.1.0' = '5.1.0',
    '5.2.0' = '5.2.0',
    '6.0.0' = '6.0.0',
    '7.0.0' = '7.0.0',
    '7.1.0' = '7.1.0',
    '8.0.0' = '8.0.0',
    '8.1.0' = '8.1.0',
    '8.2.0' = '8.2.0',
    '8.3.0' = '8.3.0',
    '8.4.0' = '8.4.0',
    '8.5.0' = '8.5.0',
    '9.0.0' = '9.0.0',
    '9.0.1' = '9.0.1',
    '10.0.0' = '10.0.0',
    '11.0.0' = '11.0.0',
    '11.1.0' = '11.1.0',
    '12.0.0' = '12.0.0',
    '12.0.1' = '12.0.1',
    '12.0.2' = '12.0.2',
    '13.0.0' = '13.0.0',
    '13.0.1' = '13.0.1',
    '13.0.2' = '13.0.2',
    '13.0.3' = '13.0.3',
    '13.1.0' = '13.1.0',
    '14.0.0' = '14.0.0',
    '14.1.0' = '14.1.0',
    '14.2.0' = '14.2.0',
    '15.0.0' = '15.0.0',
    '15.1.0' = '15.1.0',
    '15.1.1' = '15.1.1',
    '15.1.2' = '15.1.2',
    '15.2.0' = '15.2.0',
    '15.3.0' = '15.3.0',
    '16.0.0' = '16.0.0',
    '17.0.0' = '17.0.0',
    '17.0.1' = '17.0.1',
    '17.0.2' = '17.0.2',
    '17.0.3' = '17.0.3',
    '17.1.0' = '17.1.0',
    '17.1.1' = '17.1.1',
    '17.1.2' = '17.1.2',
    '17.2.0' = '17.2.0',
    '18.0.0' = '18.0.0',
    '18.0.1' = '18.0.1',
    '18.0.2' = '18.0.2',
    '18.1.0' = '18.1.0',
    '18.1.1' = '18.1.1',
    '18.2.0' = '18.2.0',
    '18.2.1' = '18.2.1',
    '18.2.2' = '18.2.2',
    '18.2.3' = '18.2.3',
    '18.4.0' = '18.4.0',
    '18.5.0' = '18.5.0',
    '18.6.0' = '18.6.0',
    '18.7.0' = '18.7.0',
    '19.0.0' = '19.0.0',
    '19.1.0' = '19.1.0',
    '19.2.0' = '19.2.0',
    '19.3.0' = '19.3.0',
    '19.4.0' = '19.4.0',
    '20.0.0' = '20.0.0',
    '20.0.1' = '20.0.1',
    '20.0.2' = '20.0.2',
    '20.0.3' = '20.0.3',
    '20.0.4' = '20.0.4',
    '20.1.0' = '20.1.0',
    '20.1.1' = '20.1.1',
    '20.2.0' = '20.2.0',
}
export const VERSION_LIST: string[] = [
    '1.0.0',
    '2.0.0',
    '2.0.1',
    '3.0.0',
    '3.1.0',
    '4.0.0',
    '4.1.0',
    '5.0.0',
    '5.1.0',
    '5.2.0',
    '6.0.0',
    '7.0.0',
    '7.1.0',
    '8.0.0',
    '8.1.0',
    '8.2.0',
    '8.3.0',
    '8.4.0',
    '8.5.0',
    '9.0.0',
    '9.0.1',
    '10.0.0',
    '11.0.0',
    '11.1.0',
    '12.0.0',
    '12.0.1',
    '12.0.2',
    '13.0.0',
    '13.0.1',
    '13.0.2',
    '13.0.3',
    '13.1.0',
    '14.0.0',
    '14.1.0',
    '14.2.0',
    '15.0.0',
    '15.1.0',
    '15.1.1',
    '15.1.2',
    '15.2.0',
    '15.3.0',
    '16.0.0',
    '17.0.0',
    '17.0.1',
    '17.0.2',
    '17.0.3',
    '17.1.0',
    '17.1.1',
    '17.1.2',
    '17.2.0',
    '18.0.0',
    '18.0.1',
    '18.0.2',
    '18.1.0',
    '18.1.1',
    '18.2.0',
    '18.2.1',
    '18.2.2',
    '18.2.3',
    '18.4.0',
    '18.5.0',
    '18.6.0',
    '18.7.0',
    '19.0.0',
    '19.1.0',
    '19.2.0',
    '19.3.0',
    '19.4.0',
    '20.0.0',
    '20.0.1',
    '20.0.2',
    '20.0.3',
    '20.0.4',
    '20.1.0',
    '20.1.1',
    '20.2.0',
];

export const LATEST_VERSION: string = last(VERSION_LIST) as string;
